import { HelpersModule } from "../helpers/helpers";

import SameHeight from 'same-height';

const helpersModule = new HelpersModule();

export class ConsultantFinderModule {

    constructor() {
        this.lat = null;
        this.lng = null;
        this.hospitalIds = "";
        this.init();
    }

    isJson(str) {
        try {
            return (JSON.parse(str) && !!str);
        } catch (e) {
            return false;
        }
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    pageload() {
        $(document).ready(function () {
            var searchParams = new URLSearchParams(window.location.search);
            var consultantType = searchParams.get("filterConsultantType");
            $("#consultantType option:selected").val(consultantType).attr("selected", "selected");

            if (consultantType == "GP") {
                $("#filterByBookable").attr("disabled", true);
            }
        });
    }

    getFinderResults(url, method) {
        return new Promise(function (resolve, reject) {

            let result = [];
            $.ajax({
                url: url,
                success: function (data) {
                    let jsonResponse = $.parseJSON(data);
                    let suggestions = jsonResponse.Suggestions;
                    let error = jsonResponse.Error;
                    if (error.indexOf("find a match for your search") > -1) {
                        console.log(method + " - returned an error");
                    }
                    else {
                        result = suggestions;
                        if (result.count == 0) {
                            console.log(method + " - returned 0 results");
                        }
                    }
                    resolve(result);
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log(method + " - " + errorThrown);
                    resolve(result);
                }
            });

        });
    }

    setupHospitalDropdown() {
        const ajaxUrl = apilocation + "Finders/SuggestHospitals/";
        const that = this;
        let html = "";
        that.getFinderResults(ajaxUrl, "setupHospitalDropdown").then(function (suggestions) {
            $.each(suggestions, function (index, item) {
                html += "<li data-value='" + item.NodeId + "'>" + item.Display + "</li>";
            });
            $("#hospitalDropdown .results").append(html);
        });
    }

    setupTreatmentDropdown() {
        const ajaxUrl = apilocation + "Finders/SuggestOnlyTreatments/";
        const that = this;
        let html = "";
        that.getFinderResults(ajaxUrl, "setupTreatmentDropdown").then(function (suggestions) {
            $.each(suggestions, function (index, item) {
                html += "<li data-value='" + item.NodeId + "'>" + item.Display + "</li>";
            });
            $("#treatmentDropdown .results").append(html);
        });
    }

    setupSpecialityDropdown() {
        const ajaxUrl = apilocation + "Finders/SuggestSpecialties/";
        const that = this;
        let html = "";
        that.getFinderResults(ajaxUrl, "setupSpecialityDropdown").then(function (suggestions) {
            $.each(suggestions, function (index, item) {
                html += "<li data-value='" + item.NodeId + "'>" + item.Display + "</li>";
            });
            $("#specialityDropdown .results").append(html);
        });
    }


    handleRadioChange() {
        $("input[type=radio][name='hospital-search']").on('change',function () {
            if (this.value == "speciality") {
                $("#treatmentDropdown").hide();
                $("#specialityDropdown").show();
            }
            else {
                $("#specialityDropdown").hide();
                $("#treatmentDropdown").show();
            }
        });
    }

    registerDropdownClicks() {
        $("#hospitalDropdown .results").on("click", "li", function (event) {
            $("#hospitalDropdown .dropdown-toggle:first-child").text($(this).text());
            $("#hospitalDropdown .dropdown-toggle:first-child").val($(this).data("value"));
        });

        $("#treatmentDropdown .results").on("click", "li", function (event) {
            $("#treatmentDropdown .dropdown-toggle:first-child").text($(this).text());
            $("#treatmentDropdown .dropdown-toggle:first-child").val($(this).data("value"));
        });

        $("#specialityDropdown .results").on("click", "li", function (event) {
            $("#specialityDropdown .dropdown-toggle:first-child").text($(this).text());
            $("#specialityDropdown .dropdown-toggle:first-child").val($(this).data("value"));
        });

    }

    resetClick() {

        $("#component-home-introduction-reset").on("click", function (e) {

            e.preventDefault();

            $("#component-home-introduction-postcode").val("");

            $("#hospitalDropdown .dropdown-toggle:first-child").text("Hospital");
            $("#hospitalDropdown .dropdown-toggle:first-child").val("");

            $("#treatmentDropdown .dropdown-toggle:first-child").text("Treatment");
            $("#treatmentDropdown .dropdown-toggle:first-child").val("");

            $("#specialityDropdown .dropdown-toggle:first-child").text("Speciality");
            $("#specialityDropdown .dropdown-toggle:first-child").val("");

            $("#component-home-introduction-treatment").prop("checked", true);
            $("#specialityDropdown").hide();
            $("#treatmentDropdown").show();

        });

    }

    searchClick() {

        let that = this;
        $("#component-home-introduction-search").on("click", function (e) {

            e.preventDefault();

            let url = $("#component-home-introduction--consultant").data("navigation-url");
            let filterString = "?filterByTreatment=&filterBySpecialty=";
            let consultantRadioButtonValue = $("input[name='hospital-search']:checked").val();

            if (consultantRadioButtonValue == "treatment") {
                let val = $("#treatmentDropdown .dropdown-toggle:first-child").val();
                let text = $("#treatmentDropdown .dropdown-toggle:first-child").text();
                if (val.length == 0) {
                    text = "";
                }
                filterString = "?filterByTreatment=" + val + "&filterBySpecialty=" + "&filterTreatmentSpeciality=" + text;
            }
            else if (consultantRadioButtonValue == "speciality") {
                let val = $("#specialityDropdown .dropdown-toggle:first-child").val();
                let text = $("#specialityDropdown .dropdown-toggle:first-child").text();
                if (val.length == 0) {
                    text = "";
                }
                filterString = "?filterByTreatment=&filterBySpecialty=" + val + "&filterTreatmentSpeciality=" + text;
            }
            let hosVal = $("#hospitalDropdown .dropdown-toggle:first-child").val();
            let postcode = $("#component-home-introduction-postcode").val();

            filterString += "&filterByHospital=" + hosVal;
            filterString += "&filterByName=&filterByPostCode=" + postcode + "&filterByBookable=false";

            if (url === undefined) {
                url = "/consultants/profiles/";
            }

            that.SetMap(postcode);
            
            window.location = url + filterString;
        });
    }

    ConsultantSearchClick() {
      
        $(".js-consultant-filter-submit").on('click', function (e) {
            e.preventDefault();

            let $form = $("#DetailsSearchForm"),
                filterConsultantType = $form.find("#consultantType option:selected").val(),
                filterTreatmentSpeciality = $form.find("#treatmentSpecialitySearch").val(),
                filterLocation = $form.find("#location-finder").val(),
                filterName = $form.find("#nameSearch").val(),
                url = $form.attr("action");          
            url += "?filterConsultantType=" + filterConsultantType + "&filterTreatmentSpeciality=" + filterTreatmentSpeciality
                + "&filterLocation=" + filterLocation + "&filterName=" + filterName;

            $form.attr('action', url).submit();
        });
    }
    


    SetMap(postcode) {
        let that = this;
        if (postcode != '') {
            let geocoder = new google.maps.Geocoder;
            geocoder.geocode({ 'address': postcode }, function (results, status) {

                if (status == google.maps.GeocoderStatus.OK) {
                    that.lat = results[0].geometry.location.lat();
                    that.lng = results[0].geometry.location.lng();

                    $.ajax({
                        type: "POST",
                        url: apilocation + 'EnquiryFormApi/NearestHospitalList',
                        data: JSON.stringify({ "postcode": postcode }),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json"
                    }).done(function (data) {

                        if (data.length > 0) {
                            // alert(data)
                            that.hospitalIds = data;
                        }

                    });

                }

            });
        }
        return that.hospitalIds;

    }

    sortLocationsByDistance(locations, userLatLong) {

        let that = this;

        function sorter(a, b) {
            return a.distance - b.distance;
        }

        let latlong = userLatLong.split(";");

        for (const element of locations) {
            element.distance = that.calculateDistance(latlong[0], latlong[1], element.lat, element.lon);
            element.distanceFriendly = element.distance.toFixed(2) + " miles";
        }

        locations.sort(sorter);

        return locations;
    }

    calculateDistance(lat1, lon1, lat2, lon2) {
        let radlat1 = Math.PI * lat1 / 180;
        let radlat2 = Math.PI * lat2 / 180;
        let theta = lon1 - lon2;
        let radtheta = Math.PI * theta / 180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;

        return dist;
    }


    navigation() {
        $("#component-home-introduction").on('click', '.js-home-introduction--menu-item', function (e) {
            e.preventDefault();
            let panelRqst = $(this)[0].getAttribute("value");
            $("#component-home-introduction--home").hide();
            $("#component-home-introduction--hospital").hide();
            $("#component-home-introduction--treatment").hide();
            $("#component-home-introduction--consultant").hide();
            $("#component-home-introduction--" + panelRqst).show();
        });

        $("#component-home-introduction").on('click', '.js-home-introduction__panel', function (e) {
            e.preventDefault();
            let panelRqst = $(this).data("value");
            $("#component-home-introduction--home").hide();
            $("#component-home-introduction--" + panelRqst).show();
        });
    }

    setupFilter() {
        $("#hospitalSearch").on("keyup", function () {
            let value = $(this).val().toLowerCase();
            $(".dropdown-menu-hospital > li> ul > li").filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });

        $("#treatmentSearch").on("keyup", function () {
            let value = $(this).val().toLowerCase();
            $(".dropdown-menu-treatment > li> ul > li").filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });

        $("#specialitySearch").on("keyup", function () {
            let value = $(this).val().toLowerCase();
            $(".dropdown-menu-speciality > li> ul > li").filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });
    }

    equalHeights() {
        SameHeight.init(".home-introduction__panel-lead", "screen and (min-width: 992px)");
    }

    setupAutoComplete() {

        $("#treatmentSpecialitySearch").attr("disabled", "disabled");

        let availableTags = [];
        availableTags.length = 0;

        let ajaxUrl = apilocation + "Finders/SuggestFilteredTreatmentsOrSpecialties";
        fetch(ajaxUrl)
            .then(function (response) {

                response.json().then(data => ({
                    data: data,
                    status: response.status
                })
                ).then(res => {
                    let data = JSON.parse(res.data);
                    $.each(data.Suggestions, function (index, item) {
                        availableTags.push(item.Display);
                    });
                    if (availableTags.length > 0) {
                        $("#treatmentSpecialitySearch").prop("disabled", false);
                    }
                });

            });

        $("#treatmentSpecialitySearch").autocomplete({
            source: availableTags
        });

    }

    init() {
        $("#component-home-introduction-treatment").prop("checked", true);
        $("#treatmentDropdown").show();
        this.setupHospitalDropdown();
        this.setupTreatmentDropdown();
        this.setupSpecialityDropdown();
        this.handleRadioChange();
        this.registerDropdownClicks();
        this.resetClick();
        this.searchClick();
        this.navigation();
        this.setupFilter();
        this.equalHeights();
        this.setupAutoComplete();
        this.ConsultantSearchClick();
    }
}
